<template>
  <div>

    <div class="va-row">
      <div class="flex xs12 md12 w-table">
        <vuestic-widget>
          <h5>{{ "t.requestLog" | translate }}</h5>
          <p>{{ "t.onlyLatest20" | translate }}</p>
          <div class="table-responsive" id="details">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th v-for="(head,index) in tableHeader" :key="index">{{ head.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(list, idx) in downloadList" :key="idx">
                  <td>{{ list.id }}</td>
                  <td>{{ list.create_time }}</td>
                  <td>{{ list.update_time }}</td>
                  <td>{{ formatDownloadResult(list.result) }}</td>
                  <td>
                    <template v-if="list.result == 'Generated'">
                      <DownloadFileButton :download-log-id="list.id" />
                      <DownloadPasswordButton :download-log-id="list.id" />
                    </template>
                  </td>
                  <!-- <td><a href="javascript:void(0)" :id="list.conditions" @click="showListDetails"><i class="el-icon-document"></i>Details</a></td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="block">
          </div>
        </vuestic-widget>
      </div>
    </div>
    <!-- <button class="btn btn-primary focus btn-sm" id="myBtnWrapper" @click="goBack">
      BACK
    </button> -->
     <button class="btn btn-primary btn-sm" id="myBtnWrapper" @click="handleRefresh">
      {{ "t.refresh" | translate }}
    </button>

    <div class="modals-page" id="refundReason">
      <vuestic-modal :show.sync="show" ref="mediumModal"
              :okText="'modal.confirm2' | translate"
              style="height: 100%;"
              :cancelText="'modal.cancel2' | translate">
        <div slot="title">{{'modal.refundReason' | translate}}</div>
        <div>
          <form>
            <div class="va-row">
              <div class="flex xs12 md12">
                <fieldset>
                  <div class="form-group with-icon-right"
                    :class="{'has-error': errors.has('refundMount'), 'valid': isFormFieldValid('refundMount')}">
                    <div class="input-group">
                      <input
                        id="simple-input"
                        name="refundMount"
                        data-vv-as="Name"
                        v-model="refundMount"
                        v-validate="'required'"
                        required/>
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label" for="simple-input">{{'forms.inputs.refundAmount' | translate}}：</label><i class="bar"></i>
                      <small v-show="errors.has('refundMount')" class="help text-danger">
                        {{ errors.first('refundMount') }}
                      </small>
                    </div>
                  </div>
                  <div class="form-group with-icon-right" :class="{'has-error': errors.has('successfulEmail'), 'valid': isSuccessfulEmailValid}">
                    <div class="input-group">
                      <input
                        id="successfulEmail"
                        name="successfulEmail"
                        v-model="successfulEmail"
                        v-validate="'required|email'"
                        required/>
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
			                <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label" for="successfulEmail">
                        {{'forms.inputs.buyerEmail' | translate}}：
                      </label>
                      <i class="bar"/>
                      <small v-show="errors.has('successfulEmail')"
                        class="help text-danger">
                      {{ errors.first('successfulEmail') }}
                      </small>
                    </div>
                  </div>

                  <div class="form-group with-icon-right"
                    :class="{'has-error': errors.has('refundExplain'), 'valid': isFormFieldValid('refundExplain')}">
                    <div class="flex md12 xs12" id="textareawrapper">
                      <div class="input-group">
                        <textarea
                          type="text"
                          name="refundExplain"
		                      data-vv-as="Name"
                          id="simple-textarea"
                          v-model="refundExplain"
                          :placeholder="$t('payment.upTo100Characters')"
                          maxlength="100"
                          rows="2"
                          :style="paddTop"
                          @focus="resizeLabel"
                          @blur="focusLabel"
                          v-validate="'required'"
                          required>
                        </textarea>
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
	                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="simple-textarea">{{'forms.inputs.description' | translate}}：</label><i class="bar"></i>
                        <small v-show="errors.has('refundExplain')" class="help text-danger">
                          {{ errors.first('refundExplain') }}
                        </small>
                      </div>
                    </div>
		              </div>

                  <div class="form-group">
                    <div class="flex md12 xs12" id="fileUploadWrapper">
                      <label for="uploadFile" class="control-label">Attachment：</label>
                      <vuestic-file-upload id="uploadFile"
                        type="single"
                        v-model="single"
                      />
                      </vuestic-widget>
                    </div>
                  </div>
                  <div class="form-group with-icon-right"
                    :class="{'has-error': errors.has('userPass'), 'valid': isFormFieldValid('userPass')}">
                    <div class="input-group">
                      <input
                        name="userPass"
		                    data-vv-as="Name"
                        type="password"
                        id="password"
                        v-model="userPass"
                        v-validate="'required'"
                        required="required"
                        onkeyup="value=value.replace(/\s/g,'')"
                        onkeydown="value=value.replace(/\s/g,'')"
                        />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
	                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label" for="password">
                      {{ $t('auth.password') }}：
                      </label>
                      <i class="bar"/>
                      <small v-show="errors.has('userPass')" class="help text-danger">{{ errors.first('userPass') }}</small>
                    </div>
                  </div>
                </fieldset>
	            </div>
            </div>
          </form>
        </div>
      </vuestic-modal>

    </div>

    <div class="flex xs12 md6 flex-center" v-if="isToastContentPresent">
      <div class="toasted-container sample-toasted-container shrink">
        <div class="toasted vuestic-toast none default">
          <i class="fa" :class="toastIcon" v-if="toastIcon"/>
          {{toastText}}
        </div>
      </div>
    </div>
    <el-dialog :title="$t('report.paramsDetails')" width="40%" :visible.sync="dialogTableVisible">
      <el-row>
        <el-col :span="12">
          <div>
            <label class="detail-label">App Id</label>
            <span class="detail-value">{{ paramsDetails.appId }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <label class="detail-label">{{ $t("recurring.merchantNumber") }}</label>
            <span class="detail-value">{{ paramsDetails.merchantNo }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>
            <label class="detail-label">{{ $t("recurring.startTime") }}</label>
            <span class="detail-value">{{ paramsDetails.startTime }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <label class="detail-label">{{ $t("recurring.endTime") }}</label>
            <span class="detail-value">{{ paramsDetails.endTime }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>
            <label class="detail-label">orderCurrency</label>
            <span class="detail-value">{{ paramsDetails.orderCurrency }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <label class="detail-label">{{ $t("recurring.orderType") }}</label>
            <span class="detail-value">{{ paramsDetails.orderType }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>
            <label class="detail-label">{{ $t("t.method") }}</label>
            <span class="detail-value">{{ paramsDetails.method }}</span>
          </div>
        </el-col>
      </el-row>

    </el-dialog>
  </div>
</template>

<script>
import { request, deepClone } from "@/utils/utils.js";
import { formatDownloadResult as translateDownloadResult } from "@/utils/downloadResult.js";
import { translateDetailLabel as mapDetailLabel } from "@/utils/detailLabel.js";
import Scrollbar from "@/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue";
import DownloadFileButton from "@/package/DownloadFileButton.vue";
import DownloadPasswordButton from "@/package/DownloadPasswordButton.vue";
export default {
  name: "payment-details",
  components: {
    Scrollbar,
    DownloadFileButton,
    DownloadPasswordButton,
  },
  data() {
    return {
      paramsDetails: {},
      dialogTableVisible: false,
      downloadList: [],
      show: true,
      single: [],
      detailInfo: [[], []],
      statusHistoryInfo: [[]],
      transactionInfo: [["Transaction Fee Rate Success", "5%", "BRL 5.00"]],
      buyerInfo: [
        { NAME: "Hiago Azevedo Gritti", CPF: "14354478757" },
        { MUID: "12345678", Email: "xxxxx@gmail.com" },
        { CEP: "12345", "Phone Number": "055-2333454" },
      ],
      deviceInfo: {
        System: "Windows 10",
        Resolution: "1366*768",
        Browser: "Chrome",
        IP: "177.207.192.143(Brazil)",
      },
      merchantInfo: {
        "App Name": "",
        "App ID": "",
        "Merchant Reference": "",
      },
      spanWrapper: "span-wrapper",
      verticalTitle: "vertical-title",
      leftText: {
        textAlign: "left",
      },
      rigthText: {
        textAlign: "right",
      },
      centerText: {
        textAlign: "center",
      },
      mgr: {
        marginRight: "30px",
      },
      mgr2: {
        marginRight: "60px",
        visibility: "hidden",
      },
      paddTop: {
        "padding-top": "18px",
      },
      refundMount: "",
      successfulEmail: "",
      refundExplain: "",
      userPass: "",
      toastText: "Application for refund has been submitted!",
      toastIcon: "fa-star-o",
      toastPosition: "top-center",
      isToastFullWidth: false,
      toastDuration: 2500,
      isToastContentPresent: false,
      closeModel: null,
    };
  },
  computed: {
    isSuccessfulEmailValid() {
      let isValid = false;
      if (this.formFields.successfulEmail) {
        isValid =
          this.formFields.successfulEmail.validated &&
          this.formFields.successfulEmail.valid;
      }
      return isValid;
    },
    tableHeader() {
      const array = [
        { label: this.$t("t.id") },
        { label: this.$t('tables.listing.recurring_create_time') },
        { label: this.$t('tables.listing.updateTime') },
        { label: this.$t("t.status") },
        { label: this.$t("t.actions") }
      ]
      return array
    }
  },
  methods: {
    formatDownloadResult(result) {
      return translateDownloadResult(this, result)
    },
    init() {
      let wrapBody = document.querySelector(".vuestic-widget-body");
      wrapBody.offsetHeight === 54
        ? (document.getElementById("myBtnWrapper").style.top = "106px")
        : (document.getElementById("myBtnWrapper").style.top = "126px");
    },
    getVerticalTabTd(key, item, str, noId) {
      if (str === "device") {
        return `<b class="${this.verticalTitle} device">${this.translateDetailLabel(key)}</b>${item}`;
      } else if (str === "buyer") {
        let mywidth = noId % 2 === 1 ? "120px" : "80px";
        return `<b class="${this.verticalTitle} buyer" style="width:${mywidth}">${this.translateDetailLabel(item)}</b> ${key}`;
      } else if (str === "merchant") {
        return `<b class="${this.verticalTitle} merchant">${this.translateDetailLabel(key)}</b> ${item}`;
      } else if (!str) {
        return `<b class="${this.verticalTitle} mgr">${this.translateDetailLabel(item)}</b> ${key}`;
      }
    },
    translateDetailLabel(label) {
      return mapDetailLabel(this, label);
    },
    goBack() {
      this.$router.push({
        name: "PaymentOrder",
      });
    },
    isFormFieldValid(field) {
      let isValid = false;
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid;
      }
      return isValid;
    },
    showMediumModal() {
      this.refundMount =
        this.successfulEmail =
        this.refundExplain =
        this.single =
        this.userPass =
          "";
      this.$refs.mediumModal.open();
      this.$refs.mediumModal.style = "";
      this.closeModel = deepClone(this.$refs.mediumModal.ok);
      this.$refs.mediumModal.ok = () => {
        this.toSubmitRefundData();
      };
    },
    resizeLabel(e) {
      e.currentTarget.style.paddingTop = "5px";
    },
    focusLabel(e) {
      e.currentTarget.style.paddingTop = "18px";
    },
    // 退款confirm 点击事件
    toSubmitRefundData() {
      if (!this.refundMount) {
        return;
      }
      if (!this.successfulEmail) {
        return;
      }
      if (!this.refundExplain) {
        return;
      }
      if (!this.userPass) {
        return;
      }
      this.commitRefundInfo();
    },
    // 获取订单信息
    getOrderInfoById(tid) {
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/order/queryById?tid=${tid}&access_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.status === 200) {
            let orderData = res.data;
            this.detailInfo[0][0] = orderData.trade_no
              ? orderData.trade_no
              : "N/A";
            this.detailInfo[0][1] =
              orderData.trans_base.order_currency &&
              orderData.trans_base.order_amount
                ? `${orderData.trans_base.order_currency} ${orderData.trans_base.order_amount}`
                : "N/A";
            this.detailInfo[0][2] = orderData.trans_base.subject
              ? orderData.trans_base.subject
              : "N/A";
            this.detailInfo[0][3] = orderData.trans_base.method
              ? orderData.trans_base.method
              : "N/A";
            this.detailInfo[0][4] = orderData.trans_base.trade_status
              ? orderData.trans_base.trade_status
              : "N/A";
            this.detailInfo[0][5] = "N/A Callback"; // 后台暂时没有
            this.detailInfo[1] = ["Refund"];

            for (let i = 0; i < orderData.trans_logs.length; i++) {
              this.statusHistoryInfo[i][0] = orderData.trans_logs[i].log_status
                ? orderData.trans_logs[i].log_status
                : "N/A";
              this.statusHistoryInfo[i][1] = orderData.trans_logs[i].create_time
                ? orderData.trans_logs[i].create_time
                : "N/A";
              this.statusHistoryInfo[i][2] = "N/A"; // 后台暂时没有
              this.statusHistoryInfo[i][3] = orderData.trans_logs[i].description
                ? orderData.trans_logs[i].description
                : "N/A";
            }

            this.merchantInfo = {
              "App Name": orderData.trans_base.app_name,
              "App ID": orderData.trans_base.app_id,
              "Merchant Reference": orderData.out_trade_no,
            };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交退款相关的信息
    commitRefundInfo() {
      let token = localStorage.getItem("Authorization");
      const param = new FormData();
      param.append(
        "trade_no",
        this.$route.params.tid || localStorage.getItem("tid")
      );
      param.append("amount", this.refundMount);
      param.append("email", this.successfulEmail);
      param.append("desc", this.refundExplain);
      param.append("password", this.userPass);
      if (this.single.length === 1) {
        param.append("file", this.single[0]);
      }
      request({
        method: "post",
        url: `api/dashboard/order/refund?access_token=${token}`,
        data: param,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          let code = res.data.code;
          this.closeModel();
          if (code == 10000) {
            this.toastText = res.data.msg || "Success!";
            this.launchToast();
          } else {
            this.toastText = res.data.msg;
            this.launchToast();
          }
        })
        .catch((err) => {
          this.toastText = err.msg;
          this.launchToast();
        });
    },

    launchToast() {
      this.isToastContentPresent = true;
      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth,
      });
      this.isToastContentPresent = false;
    },
    getDownloadList(flag) {
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/order/download-list?access_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        if (res.data.code == 10000) {
          if (flag) {
            this.showToast("Refresh successfully", {
              icon: this.toastIcon,
              position: this.toastPosition,
              duration: this.toastDuration,
              fullWidth: this.isToastFullWidth,
            });
          }
          this.downloadList = res.data.data;
        }
      });
    },
    handleRefresh() {
      this.getDownloadList(true);
    },
    showListDetails(e) {
      this.dialogTableVisible = true;
      if(e.target.id){
        this.paramsDetails = JSON.parse(e.target.id)
      }
    },
  },
  created() {
    //this.init()
    this.getDownloadList();

    this.$nextTick(() => {
      this.$validator.validateAll();
    });
  },
  mounted() {
    //this.getOrderInfoById(this.$route.params.tid || localStorage.getItem('tid'))
  },
  beforeDestroy() {},
};
</script>

<style  lang="scss" scoped>
table {
  text-align: center;
}
.vuestic-breadcrumbs__help-section {
  display: none;
}
.span-wrapper {
  display: inline-block;
  height: 37px;
  line-height: 37px;
}
/deep/ .vertical-title {
  font-size: 16px;
  font-weight: 700;
  display: inline-block;
  width: 140px;
  height: 37px;
  line-height: 37px;
  text-align: right;
  padding-right: 15px;
}
/deep/ .device {
  width: 90px;
}
#merchant {
  height: 228px;
  .table td {
    text-align: left;
  }
}
#transCoat {
  height: 175px;
}
#transCoat .table thead th {
  width: 300px;
}
.first-td-padding td:first-child {
  padding-left: 0.5rem !important;
}
#details .table-striped tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}
#refundReason .vuestic-modal .modal-header {
  .modal-title {
    margin-bottom: 0;
    line-height: 1.5;
    flex: 1;
    display: flex;
    justify-content: center;
  }
}
#refundReason .vuestic-widget .vuestic-widget-header {
  padding-left: 10px;
}
#refundReason .form-group {
  #fileUploadWrapper .control-label {
    position: relative;
  }
  #fileUploadWrapper.flex {
    padding: 0;
  }
  #textareawrapper.flex {
    padding: 0;
  }
  #uploadFile {
    height: calc(100% - 30px);
  }
}
/deep/ #refundReason {
  .vuestic-modal .modal {
    display: flex;
    align-items: center;
  }
}
#myBtnWrapper {
  position: absolute;
  top: 146px;
  right: 80px;
}
/deep/ .vuestic-scrollbar {
  .scrollbar-wrapper {
    padding-top: 14px;
    max-height: 600px;
  }
}
/deep/ .buyer {
  width: 120px;
}
/deep/ .merchant {
  width: 150px;
}
.detail-label{
  margin-left: 30px;
  font-size: 14px;
  margin-right: 10px;
  &::after{
    content: ":"
  }
}
.detail-value{
  font-weight: bold;
  font-size: 14p;
}
.el-row{
  margin-bottom: 8px;
}
#myBtnWrapper{
  top: 225px !important;
}
</style>
